<div (click)="$event.stopPropagation()" class="client-search-container">
  <input
    (focus)="showPanel()"
    (keyup)="applyFilter($event)"
    (search)="clearFilter()"
    [(ngModel)]="_searchValue"
    class="client-search-input"
    placeholder="Search all clients..."
    type="search"
  />
  <div *ngIf="_panelVisible" class="client-search-floating-panel">
    <div class="client-search-table-container">
      <app-table
        *ngIf="_dataLoaded"
        [columnDefinitions]="_tableColumnDefinitions"
        [columnsToDisplay]="_tableColumnsToDisplay"
        [dataSource]="_tableData"
        [showPager]="false"
        kind="standard"
        pageSize="12"
      />
    </div>
  </div>
</div>
